import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthSessionService } from '../../features/auth/services/auth-session.service';
import { AuthConfigService } from '../services/auth-config.service';

type PermissionGuardData = {
  permission?: string;
  permissions?: string[];
  role?: string;
  roles?: string[];
};

export const permissionGuard: CanActivateFn = (route, state) => {
  const config = inject(AuthConfigService);
  const router = inject(Router);
  const session = inject(AuthSessionService);

  const data = (route.data ?? {}) as PermissionGuardData;
  const permissions = [...(data.permission ? [data.permission] : []), ...(data.permissions ?? [])];
  const roles = [...(data.role ? [data.role] : []), ...(data.roles ?? [])];

  if (!config.enabled || config.bypassPermissions) {
    return true;
  }

  if (!session.isAuthenticated()) {
    return router.createUrlTree(['/inicio-sesion'], {
      queryParams: state.url ? { redirectTo: state.url } : undefined,
    });
  }

  const hasPermissions = permissions.length ? session.hasAnyPermission(permissions) : true;
  const hasRoles = roles.length ? session.hasAnyRole(roles) : true;

  if (hasPermissions && hasRoles) {
    return true;
  }

  return router.createUrlTree(['/acceso-denegado']);
};
